import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex-colum h-100" }
const _hoisted_2 = { class: "flex-row bd-highlight mb-3" }
const _hoisted_3 = {
  class: "align-self-center",
  style: {"height":"30px","margin-bottom":"5px"}
}
const _hoisted_4 = {
  class: "input-group align-self-center ms-auto bd-highlight mr-5",
  style: {"width":"15%"}
}
const _hoisted_5 = ["value"]
const _hoisted_6 = {
  class: "input-group align-self-center bd-highlight",
  style: {"width":"25%"}
}
const _hoisted_7 = { class: "table table-bordered table-striped table-sm member-list" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "序号"),
    /*#__PURE__*/_createElementVNode("th", null, "姓名"),
    /*#__PURE__*/_createElementVNode("th", null, "ID"),
    /*#__PURE__*/_createElementVNode("th", null, "手机号"),
    /*#__PURE__*/_createElementVNode("th", null, "职位"),
    /*#__PURE__*/_createElementVNode("th", null, "门店"),
    /*#__PURE__*/_createElementVNode("th", null, "状态"),
    /*#__PURE__*/_createElementVNode("th", null, "身份证"),
    /*#__PURE__*/_createElementVNode("th", null, "操作")
  ])
], -1)
const _hoisted_9 = { id: "member-list" }
const _hoisted_10 = { class: "flex-row" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "flex-row flex-align-center" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_AddEmployeeDialog = _resolveComponent("AddEmployeeDialog")!
  const _component_LoadingDialog = _resolveComponent("LoadingDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.openAddEmployeeDialog && $setup.openAddEmployeeDialog(...args)))
          }, "添加")
        ]),
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("select", {
            class: "form-select",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.shop) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shops, (value, idx) => {
              return (_openBlock(), _createElementBlock("option", {
                key: idx,
                value: value.id
              }, _toDisplayString(value.name), 9, _hoisted_5))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.shop]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "employee-keywords",
            class: "form-control",
            placeholder: "搜索",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.keywords) = $event))
          }, null, 512), [
            [_vModelText, _ctx.keywords]
          ]),
          _createElementVNode("button", {
            class: "btn btn-outline-secondary",
            type: "button",
            onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.loadEmployeeList(1)))
          }, "搜索")
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("table", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("tbody", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dataList, (value, idx) => {
              return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                _createElementVNode("td", null, _toDisplayString(50 * ($setup.nowPage - 1) + idx + 1), 1),
                _createElementVNode("td", null, _toDisplayString(value.name), 1),
                _createElementVNode("td", null, _toDisplayString(value.id), 1),
                _createElementVNode("td", null, _toDisplayString(value.mobile), 1),
                _createElementVNode("td", null, _toDisplayString(value.jobTitle || "-"), 1),
                _createElementVNode("td", null, _toDisplayString($setup.getShopName(value.shop)), 1),
                _createElementVNode("td", _hoisted_10, [
                  _createTextVNode(_toDisplayString(value.disable ? "已离职" : "在职") + " ", 1),
                  (value.disable)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        style: {"text-decoration":"underline","color":"dodgerblue","cursor":"pointer"},
                        onClick: ($event: any) => ($setup.enableEmployee(value.id, value.name))
                      }, "(复职)", 8, _hoisted_11))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", null, _toDisplayString(value.idcard || "-"), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("img", {
                      class: "button-icon",
                      src: "/assets/ic_edit.png",
                      onClick: ($event: any) => ($setup.openEditEmployeeDialog(value.id))
                    }, null, 8, _hoisted_13),
                    _createElementVNode("img", {
                      class: "button-icon img-margin",
                      src: "/assets/ic_trash.png",
                      onClick: ($event: any) => ($setup.deleteEmployee(value.id, value.name))
                    }, null, 8, _hoisted_14)
                  ])
                ])
              ]))
            }), 128))
          ])
        ]),
        _createVNode(_component_Pagination, {
          page: $setup.nowPage,
          max: $setup.totalPage/50,
          onLoadPage: $setup.loadEmployeeList
        }, null, 8, ["page", "max", "onLoadPage"])
      ])
    ]),
    _createVNode(_component_AddEmployeeDialog, {
      show: _ctx.showAddDialog,
      item: _ctx.editing,
      onCancel: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showAddDialog = false)),
      onConfirm: $setup.editEmployee
    }, null, 8, ["show", "item", "onConfirm"]),
    _createVNode(_component_LoadingDialog, { show: _ctx.showLoadingDialog }, null, 8, ["show"])
  ], 64))
}